import { render, staticRenderFns } from "./PackageCode.vue?vue&type=template&id=9b24879a&scoped=true&"
import script from "./PackageCode.vue?vue&type=script&lang=js&"
export * from "./PackageCode.vue?vue&type=script&lang=js&"
import style0 from "./PackageCode.vue?vue&type=style&index=0&id=9b24879a&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b24879a",
  null
  
)

export default component.exports